import Media from "./Media";
import MoreIcon from "./more-icon";
import CancelIcon from "./cancel-icon";
import RemoveIcon from "./remove-icon";
import FileIcon from "./file-icon";

export default Media;

export { MoreIcon, CancelIcon, RemoveIcon, FileIcon };
